import axios from "../utils/axios";

// ==========================================
// Blog Posts
// ==========================================

export const getPosts = async (params) => {
    const response = await axios.get("/admin/posts", { params });
    return response.data;
};

export const getPostById = async (id) => {
    const response = await axios.get(`/admin/posts/${id}`);
    return response.data;
};

export const createPost = async (data) => {
    const response = await axios.post("/admin/posts", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export const updatePost = async (id, data) => {
    // For file uploads with PUT, we typically use POST with _method=PUT
    if (data instanceof FormData) {
        data.append("_method", "PUT");
        const response = await axios.post(`/admin/posts/${id}`, data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    }
    const response = await axios.put(`/admin/posts/${id}`, data);
    return response.data;
};

export const deletePost = async (id) => {
    const response = await axios.delete(`/admin/posts/${id}`);
    return response.data;
};

// ==========================================
// Blog Categories
// ==========================================

export const getPostCategories = async (params) => {
    const response = await axios.get("/admin/post-categories", { params });
    return response.data;
};

export const getPostCategoryById = async (id) => {
    const response = await axios.get(`/admin/post-categories/${id}`);
    return response.data;
};

export const createPostCategory = async (data) => {
    const response = await axios.post("/admin/post-categories", data);
    return response.data;
};

export const updatePostCategory = async (id, data) => {
    const response = await axios.put(`/admin/post-categories/${id}`, data);
    return response.data;
};

export const deletePostCategory = async (id) => {
    const response = await axios.delete(`/admin/post-categories/${id}`);
    return response.data;
};

// ==========================================
// Blog Tags
// ==========================================

export const getPostTags = async (params) => {
    const response = await axios.get("/admin/post-tags", { params });
    return response.data;
};

export const getPostTagById = async (id) => {
    const response = await axios.get(`/admin/post-tags/${id}`);
    return response.data;
};

export const createPostTag = async (data) => {
    const response = await axios.post("/admin/post-tags", data);
    return response.data;
};

export const updatePostTag = async (id, data) => {
    const response = await axios.put(`/admin/post-tags/${id}`, data);
    return response.data;
};

export const deletePostTag = async (id) => {
    const response = await axios.delete(`/admin/post-tags/${id}`);
    return response.data;
};
